export function getBranchEnv() {
  return process.env.NEXT_PUBLIC_ENV
}
